import { useEffect, useState, useTransition } from "react"
import AddingParticipants from "../AddingParticipants/addingParticipants"
import "./discussionSidebarLight.css"
import "./discussionSidebarDark.css"
import { useToast } from '@chakra-ui/react'
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import { useDispatch, useSelector } from "react-redux"
import AssignUsersDropDown from "../assignUsersDropDown/assignUsersDropDown"
import axios from "axios"
import { useLocation, useNavigate } from "react-router"
import sockets from "../../../../socket/socket"
import { getmyinfoAction } from "../../../../redux/reducer/getmyinfo/action/action"
import { getItemChatAction } from "../../../../redux/reducer/getChatItem/action/action"
import { getMessageItem } from "../../../../redux/reducer/getMessageItem/action/action"
import { useSearchParams } from "react-router-dom"
import ModalForEditChatImage from "../modalForEditChatImage/modalForEditChatImage"

const socket = sockets;

export default function DiscussionSidebar({ otherChatOptionsFuncClose }) {
    const [openModalForAddEmploys, setOpenModalForAddEmploys] = useState(false);
    const getChatInfo = useSelector(chatInfi => chatInfi.getChatInfoByIDReducer);
    let getmyinfo = useSelector(compID => compID.getMayInfoReducer);
    const getDarkModoe = useSelector(darkModes => darkModes);
    const [data, setData] = useState([]);
    const [loadingUser, setloadingUser] = useState(false);
    const [copied, setCopied] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();
    const onlineUSers = useSelector(onlineUSers => onlineUSers);
    const [isPinChat, setisPinChat] = useState(false)
    const dispatch = useDispatch();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const chatID = searchParams.get("chatID");
    // для обновления сокета
    const [chooseWokers, setChooseWokers] = useState([]);
    const gerChekcedCompany = useSelector((allWorkers) => allWorkers);

    const openModalFunc = () => {
        setOpenModalForAddEmploys(!openModalForAddEmploys)

    }
    useEffect(() => {
        setloadingUser(true)
        if (getChatInfo.data && getChatInfo.data.chatOptions && getChatInfo.data.chatOptions.chatParticipantsID) {
            axios.get(`/getUserByIDForChat/api?ID=${getChatInfo.data.chatOptions.chatParticipantsID}`)
                .then(function (response) {
                    // handle success
                    const data = response.data.data;

                    // Находим индекс текущего пользователя (администратора) в полученных пользователях
                    const index = data.findIndex(user => user._id === getChatInfo.data.chatOptions.creatorOfThisChat);

                    // Если пользователь найден в массиве, перемещаем его в начало массива
                    if (index !== -1) {
                        const specificUser = data.splice(index, 1)[0]; // Удаляем пользователя из массива
                        data.unshift(specificUser); // Помещаем пользователя в начало массива
                    }

                    // Устанавливаем отсортированные данные
                    setData(data);
                    setloadingUser(false)
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                    setloadingUser(false)
                });
        }
    }, [getChatInfo]); // Добавляем getChatInfo в зависимости, чтобы useEffect запускался при его изменении

    const copyToClipboard = () => {
        const url = window.location.href;
        navigator.clipboard.writeText(url)
            .then(() => {
                setCopied(true);
                toast({
                    position: "top",
                    title: 'Ссылка скопирована',
                    description: "Ссылка скопирована",
                    status: 'success',
                    duration: 1000,
                    isClosable: true,
                })
                setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds

            })
            .catch(err => console.error('Failed to copy URL: ', err));
    };
    // изменить имя чата
    const changeChatName = async (newValue) => {
        try {
            if (getChatInfo.data) {
                if (getChatInfo.data.chatOptions.chatName !== newValue) {
                    await axios.put("/changeChatName/api", { chatID: getChatInfo.data._id, value: newValue });
                    axiosGetWorkers("/getCurrendCompanyWorkers/api");
                }

            }
        } catch (error) {
            console.error('Ошибка при изменении имени чата:', error);
        }
    }
    // Выйди из чата
    const leaveTheConversation = async () => {
        await axios.put("/leaveTheConversation/api", { chatID: getChatInfo.data._id });
        if (socket) {
            socket.emit("updateChatSocketWorkers", getChatInfo.data.chatOptions.chatParticipantsID);
        }
        navigate("/chat/conversations")
    }
    // удаление чата и внутреннее сообщение
    const handleDeleteChat = async () => {
        try {

            await axios.delete("/deleteChat/api", { data: { chatID: getChatInfo.data._id } });
            socket.emit("updateChatSocketWorkers", getChatInfo.data.chatOptions.chatParticipantsID);
            // socket.emit("deleteChat", getChatInfo.data.chatOptions.chatParticipantsID);
            navigate(location.pathname)


        } catch (error) {
            console.error("Error deleting chat:", error);
        }
    }
    const formatDate = () => {
        let text;
        if (getChatInfo.data.chatOptions?.chatType == "canal" && getChatInfo.data.chatOptions?.chatHidden == true) {
            text = "Закрытый канал"
        } else if (getChatInfo.data.chatOptions?.chatType == "canal" && getChatInfo.data.chatOptions?.chatHidden == false) {
            text = "Открытая канал"
        } else if (getChatInfo.data.chatOptions?.chatType == "Conversation" && getChatInfo.data.chatOptions?.chatHidden == true) {
            text = "Закрытый беседа"
        } else if (getChatInfo.data.chatOptions?.chatType == "Conversation" && getChatInfo.data.chatOptions?.chatHidden == false) {
            text = "Открытая беседа"
        } else if (getChatInfo.data.chatOptions?.chatType == "public" && getChatInfo.data.chatOptions?.chatHidden == false) {
            text = "публичный чат"
        }
        // getChatInfo.data.chatOptions.chatHidden
        const date = new Date(getChatInfo.data.chatOptions && getChatInfo.data.chatOptions.chatDate);
        const formattedDate = `${text}, создана ${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} в ${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`;
        return formattedDate
    };

    const handlePinChat = async () => {
        axios.put('/addPinChat/api', {
            data: getChatInfo
        })
            .then(function (response) {
                console.log(response);
                dispatch(getmyinfoAction("/registration/v2/api"))
            })
            .catch(function (error) {
                console.log(error);
                dispatch(getmyinfoAction("/registration/v2/api"))


            });
    }

    const hanldeNotifyChat = async () => {
        axios.put('/chatnotification/api', {
            data: getChatInfo
        })
            .then(function (response) {

            })
            .catch(function (error) {
                console.log(error);
                dispatch(getmyinfoAction("/registration/v2/api"))


            });
    }



    // console.log(getmyinfo.myinfo.settings.pinChatsID
    //     ,"getmyinfo");

    useEffect(() => {

        if (getmyinfo && getmyinfo.myinfo && getmyinfo.myinfo.settings && getmyinfo.myinfo.settings.pinChatsID) {
            if (getmyinfo.myinfo.settings.pinChatsID.find(item => item == getChatInfo.data._id)) {
                setisPinChat(true)
            } else {
                setisPinChat(false)
            }
        }
        if (location.pathname == "/chat/conversations") {
            dispatch(getItemChatAction("/getItemChat/api?filter=Conversations"));
        } else if (location.pathname == "/chat/public") {
            dispatch(getItemChatAction("/getItemChat/api?filter=Public"));
        } else if (location.pathname == "/chat/private") {
            dispatch(getItemChatAction("/getItemChatPrivate/api?filter=private"));
        }

    }, [getmyinfo.myinfo.settings])

    const creatPrivateMessage = (item, e) => {
        e.stopPropagation();
        const data = {
            workerID: item._id
        }
        axios.post('/creatPrivateChat/api', {
            data
        })
            .then(function (response) {
                console.log(response.data.data._id
                );

                axiosGetWorkers("/getCurrendCompanyWorkers/api");
                // navigate(`/chat/private?chatID=${response.data.data._id}`)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        function navigateDeletChat(params) {
            if (location.pathname == "/chat/conversations") {
                dispatch(getMessageItem(`/getItemMessages/api?chatID=${chatID}`));
                navigate("/chat/conversations")


            } else if (location.pathname == "/chat/public") {
                dispatch(getMessageItem(`/getItemMessages/api?chatID=${chatID}`));
                navigate("/chat/public")


            } else if (location.pathname == "/chat/private") {
                dispatch(getMessageItem(`/getItemMessages/api?chatID=${chatID}`));
                navigate("/chat/private")


            }
        }
        if (socket) {

            socket.on('deleteChat', navigateDeletChat);

            return () => {
                socket.off('deleteChat', navigateDeletChat);
            };
        }
    }, []);

    // получение идентификатора пользователей этого чата
    function axiosGetWorkers(url) {
        axios
            .get(url)
            .then(function (response) {
                // handle success
                setChooseWokers([]);
                if (response.data.data) {
                    const newChooseWokers = response.data.data.map(item => item.workerID);
                    setChooseWokers(prevWorkers => [...prevWorkers, ...newChooseWokers]);
                    const adminWorkerID = gerChekcedCompany?.rootReducer?.users?.adminInfo?.workerID;
                    if (adminWorkerID) {
                        setChooseWokers(prevWorkers => [...prevWorkers, adminWorkerID]);
                    }

                    if (newChooseWokers.length > 0 || adminWorkerID) {
                        // socket.emit("updateCreatMessage", [...newChooseWokers, adminWorkerID]);
                        socket.emit("updateChatSocketWorkers", [...newChooseWokers, adminWorkerID]);
                    } else {
                        alert("No workers found");
                    }
                }
            })
            .catch(function (error) {
                // handle error
                console.error("Error fetching data:", error);
            });
    }
    return (
        <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "discussionSidebarContDark" : "discussionSidebarContLight"}>

            <div>
                <div className="sideIfnoCont">
                    <div className="frame117">
                        <div className="frame107">
                            {
                                location.pathname == "/chat/private" ?
                                    <div className="frame108">

                                        <div style={{ width: "100%" }}></div>
                                    </div>
                                    :
                                    <div className="frame108">
                                        {/* <Avatar name={getChatInfo.data.chatOptions && getChatInfo.data.chatOptions.chatName} /> */}
                                        <ModalForEditChatImage data={getChatInfo.data.chatOptions} />
                                        <input
                                            type="text"
                                            placeholder="Группа тестирование"
                                            defaultValue={getChatInfo.data.chatOptions && getChatInfo.data.chatOptions.chatName}
                                            onBlur={(e) => changeChatName(e.target.value)}
                                        />
                                    </div>
                            }

                            <div onClick={otherChatOptionsFuncClose} style={{ cursor: "pointer" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="closeOtherDiscussion">
                                    <path d="M1 1L15 15M1.00003 15L8.00003 8L15 1" stroke="#393939" strokeWidth="1.5" strokeLinecap="round" />
                                </svg>
                            </div>
                        </div>
                        {

                            location.pathname !== "/chat/private" ? <p>{formatDate()}</p> : ""
                        }

                    </div>
                </div>
                <div className="sideFuncCont">
                    <div className="frame116">
                        <div className="frame117" onClick={handlePinChat}>
                            <div>
                                {
                                    isPinChat ?
                                        <div>

                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                                                    <path d="M7.91473 10.8535L2.5 16.2682" stroke="#3B79F6" strokeWidth="1.24955" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M4.16797 6.6762L11.8256 14.3338L13.2393 12.9201L12.9126 9.76603L17.5019 5.873L12.6289 1L8.73578 5.58914L5.58168 5.26249L4.16797 6.6762Z" stroke="#3B79F6" strokeWidth="1.24955" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M1.5 1L19.5 19" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <p>Откермить в меню</p>
                                        </div>
                                        :
                                        <div>

                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none" style={{ width: "18.661px", height: "21.224px" }}>
                                                    <path fillRule="evenodd" clip-rule="evenodd" d="M7.9098 3.3139C5.42451 3.26895 2.99011 4.42363 1.46706 6.54904C1.2451 6.85879 1.02513 7.23981 0.644514 7.89909L0.617424 7.94602C0.613431 7.95293 0.609416 7.95988 0.605386 7.96684C0.559851 8.04558 0.512575 8.12732 0.476457 8.20703C0.131896 8.96749 0.372503 9.86545 1.05113 10.3518C1.12227 10.4027 1.20408 10.4499 1.28289 10.4953C1.28986 10.4993 1.29681 10.5033 1.30372 10.5073L7.47415 14.0698L3.84915 20.3485C3.64205 20.7072 3.76495 21.1659 4.12367 21.373C4.48239 21.5801 4.94108 21.4572 5.14819 21.0985L8.77319 14.8198L14.9436 18.3823C14.9505 18.3863 14.9575 18.3903 14.9645 18.3944C15.0432 18.4399 15.1249 18.4872 15.2046 18.5233C15.9651 18.8678 16.8631 18.6272 17.3494 17.9486C17.4003 17.8775 17.4475 17.7956 17.4929 17.7168C17.4969 17.7098 17.5009 17.7029 17.5049 17.696L17.532 17.6491C17.9127 16.9898 18.1326 16.6088 18.2899 16.2617C19.3693 13.8795 19.1518 11.1933 17.8695 9.06325L17.9776 8.87596C19.5654 6.12578 18.6231 2.60913 15.873 1.02131C13.1228 -0.566504 9.60612 0.375776 8.01831 3.12596L7.9098 3.3139ZM9.547 3.51982C10.0272 3.63337 10.5021 3.79425 10.9651 4.00405C11.3122 4.16132 11.6932 4.38131 12.3525 4.76196L14.3949 5.94115C15.0542 6.32176 15.4352 6.54172 15.7449 6.76368C16.1577 7.0595 16.5341 7.38993 16.8723 7.74862C17.7624 5.78183 17.0319 3.42247 15.123 2.32035C13.2139 1.21817 10.8052 1.76537 9.547 3.51982ZM8.27027 4.83275C6.13288 4.66048 3.99316 5.59908 2.68633 7.42276C2.51289 7.66479 2.33168 7.97684 1.91646 8.69602C1.88617 8.74848 1.86816 8.77972 1.85496 8.80353C1.84656 8.81867 1.84233 8.82703 1.84233 8.82703C1.79387 8.93516 1.82799 9.06248 1.92402 9.13189C1.92402 9.13189 1.93187 9.13701 1.9467 9.14592C1.97004 9.15993 2.00126 9.17799 2.05372 9.20828L8.87367 13.1458L15.6936 17.0833C15.7461 17.1136 15.7773 17.1316 15.8011 17.1448C15.8153 17.1526 15.8221 17.1561 15.8243 17.1572C15.9329 17.2064 16.0606 17.1718 16.1301 17.0749C16.1276 17.0784 16.1302 17.0752 16.1435 17.053C16.1575 17.0297 16.1756 16.9985 16.2059 16.946C16.6211 16.2268 16.8007 15.9139 16.9236 15.6427C17.8511 13.5956 17.5917 11.2689 16.3685 9.50286C15.9697 8.92709 15.4682 8.41077 14.8712 7.98295C14.6292 7.80952 14.3171 7.62831 13.5979 7.21309L11.6494 6.08809C10.9302 5.67287 10.6173 5.49323 10.346 5.37035C9.67357 5.06565 8.97193 4.8893 8.27027 4.83275Z" fill="#3B79F6" />
                                                </svg>
                                            </div>
                                            <p>Закрепить в меню</p>
                                        </div>
                                }

                            </div>
                        </div>
                        <div className="frame117" onClick={hanldeNotifyChat}>
                            <div>
                                {
                                    getmyinfo.myinfo.settings && getmyinfo.myinfo.settings.DisableNotificationsChat ?
                                        <div>
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none" style={{ width: "18px", height: "19.997px" }}>
                                                    <path d="M4.77049 5.5C4.59277 6.10971 4.5 6.74975 4.5 7.4C4.5 14.8667 1.5 17 1.5 17H16.5" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6.25781 2.87452C7.38303 1.67428 8.90919 1 10.5005 1C12.0918 1 13.6179 1.67428 14.7431 2.87452C15.8683 4.07475 16.5005 5.70261 16.5005 7.4C16.5005 14.8667 19.5005 17 19.5005 17" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12.2295 20C12.0537 20.3031 11.8014 20.5547 11.4977 20.7295C11.1941 20.9044 10.8499 20.9965 10.4995 20.9965C10.1491 20.9965 9.80493 20.9044 9.50133 20.7295C9.19773 20.5547 8.94533 20.3031 8.76953 20" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M1.5 2L19.5 20" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <p>Отключить уведомления</p>
                                        </div> :
                                        <div>
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none" style={{ width: "18px", height: "19.997px" }}>
                                                    <path d="M4.77049 5.5C4.59277 6.10971 4.5 6.74975 4.5 7.4C4.5 14.8667 1.5 17 1.5 17H16.5" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6.25781 2.87452C7.38303 1.67428 8.90919 1 10.5005 1C12.0918 1 13.6179 1.67428 14.7431 2.87452C15.8683 4.07475 16.5005 5.70261 16.5005 7.4C16.5005 14.8667 19.5005 17 19.5005 17" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12.2295 20C12.0537 20.3031 11.8014 20.5547 11.4977 20.7295C11.1941 20.9044 10.8499 20.9965 10.4995 20.9965C10.1491 20.9965 9.80493 20.9044 9.50133 20.7295C9.19773 20.5547 8.94533 20.3031 8.76953 20" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M1.5 2L19.5 20" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <p>Включить уведомления</p>
                                        </div>
                                }

                            </div>
                        </div>
                        <div className="frame117" onClick={copyToClipboard}>
                            <div>
                                <div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="12" viewBox="0 0 23 12" fill="none" style={{ width: "20px", height: "9.995px" }}>
                                            <path d="M13.5 5.9976C13.5 3.5059 11.183 1 8.35714 1C8.02241 1 6.91904 1.00001 6.64286 1.00001C3.80254 1.00001 1.5 3.23752 1.5 5.9976C1.5 8.376 3.20973 10.3664 5.5 10.8714C5.86756 10.9525 6.25006 10.9952 6.64286 10.9952" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M9.5 5.99761C9.5 8.48931 11.817 10.9952 14.6429 10.9952C14.9776 10.9952 16.081 10.9952 16.3571 10.9952C19.1975 10.9952 21.5 8.75771 21.5 5.99761C21.5 3.61921 19.7903 1.62885 17.5 1.12384C17.1324 1.04279 16.7499 1 16.3571 1" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <p>Скопирвать ссылку</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AddingParticipants openModalForAddEmploys={openModalForAddEmploys} setOpenModalForAddEmploys={setOpenModalForAddEmploys} data={getChatInfo?.data} />
                {
                    location.pathname !== "/chat/private" ?
                        <button className="addUserBTN" onClick={openModalFunc}>
                            <div>
                                <p>Добавить пользователя</p>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                        <path d="M11.8086 8C11.8086 7.58579 11.4728 7.25 11.0586 7.25C10.6444 7.25 10.3086 7.58579 10.3086 8V10.25H8.05859C7.64438 10.25 7.30859 10.5858 7.30859 11C7.30859 11.4142 7.64438 11.75 8.05859 11.75H10.3086V14C10.3086 14.4142 10.6444 14.75 11.0586 14.75C11.4728 14.75 11.8086 14.4142 11.8086 14V11.75H14.0586C14.4728 11.75 14.8086 11.4142 14.8086 11C14.8086 10.5858 14.4728 10.25 14.0586 10.25H11.8086V8Z" fill="white" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.0586 0.25C5.12153 0.25 0.308594 5.06294 0.308594 11C0.308594 16.9371 5.12153 21.75 11.0586 21.75C16.9957 21.75 21.8086 16.9371 21.8086 11C21.8086 5.06294 16.9957 0.25 11.0586 0.25ZM1.80859 11C1.80859 5.89137 5.94996 1.75 11.0586 1.75C16.1672 1.75 20.3086 5.89137 20.3086 11C20.3086 16.1086 16.1672 20.25 11.0586 20.25C5.94996 20.25 1.80859 16.1086 1.80859 11Z" fill="white" />
                                    </svg>
                                </div>
                            </div>
                        </button> : ""
                }

                {

                    location.pathname !== "/chat/private" ? <div className="ParticipantsCont">
                        <div>
                            <p>Участинки:</p>
                        </div>
                        <div className="ParticipantsUsersForForeach">
                            {
                                loadingUser ? <div class="spinner"></div> : ""

                            }
                            {
                                data.map((item, index) => {


                                    return (
                                        <div className="ParticipantsUsers" key={index} onClick={(e) => {
                                            if (getChatInfo.data.chatOptions && getChatInfo.data.chatOptions.creatorOfThisChat !== item._id) {
                                                creatPrivateMessage(item, e);
                                            }
                                        }}>
                                            <div>

                                                {
                                                    onlineUSers.AllOnlineUsersReducer.allOnlineUsers.includes(item._id) ?
                                                        <Avatar size={"md"} src={item.img ? `/${item.img}` : 'https://bit.ly/broken-link'}>
                                                            <AvatarBadge boxSize='1em' bg='green.500' />
                                                        </Avatar>
                                                        :
                                                        <Avatar size={"md"} src={item.img ? `/${item.img}` : 'https://bit.ly/broken-link'} />
                                                }
                                                <div>
                                                    <p>{item.name ? item.name : item.tel}</p>
                                                    {
                                                        onlineUSers.AllOnlineUsersReducer.allOnlineUsers.includes(item._id) ?
                                                            <p style={{ color: "#22C55E" }}>В сети</p>
                                                            :
                                                            <p>Не в сети</p>
                                                    }

                                                </div>
                                            </div>
                                            {
                                                getChatInfo.data.chatOptions && getChatInfo.data.chatOptions.creatorOfThisChat == item._id ? <p>Владелец</p> : ""
                                            }

                                            {
                                                (() => {
                                                    if (getmyinfo.myinfo._id == getChatInfo.data.chatOptions.creatorOfThisChat) {
                                                        if (getChatInfo.data.chatOptions.creatorOfThisChat !== item._id) {
                                                            return <AssignUsersDropDown item={item} />
                                                        }
                                                    }
                                                })()
                                            }


                                        </div>
                                    )
                                })
                            }

                        </div>

                    </div> : ""
                }

            </div>
            <div className="discussionSidebarFooter">

                {
                    getChatInfo.data &&
                    getChatInfo.data.chatOptions &&
                    getChatInfo.data.chatOptions.creatorOfThisChat !== getmyinfo.myinfo._id &&
                    <div className="LeaveTheConversation" onClick={leaveTheConversation}>
                        <div >
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
                                    <path d="M1 19.3844V4.61516C1 2.57596 2.65311 0.922852 4.69231 0.922852H7.15384C9.19304 0.922852 10.8462 2.57596 10.8462 4.61516V19.3844C10.8462 21.4236 9.19304 23.0767 7.15384 23.0767H4.69231C2.65311 23.0767 1 21.4236 1 19.3844Z" stroke="#EE6B6B" strokeWidth="1.84615" />
                                    <path d="M18.2305 0.922852H20.692C23.4109 0.922852 25.6151 3.12699 25.6151 5.84593V18.1536C25.6151 20.8725 23.4109 23.0767 20.692 23.0767H18.2305" stroke="#EE6B6B" strokeWidth="1.84615" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20.6938 11.9999L17.0015 15.6922M10.8477 11.9999H20.6938H10.8477ZM20.6938 11.9999L17.0015 8.30762L20.6938 11.9999Z" stroke="#EE6B6B" strokeWidth="1.84615" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <p>Выйти из беседы</p>
                        </div>
                    </div>
                }

                {
                    getChatInfo.data &&
                    getChatInfo.data.chatOptions &&
                    getChatInfo.data.chatOptions.creatorOfThisChat == getmyinfo.myinfo._id &&
                    <div className="Archive" onClick={handleDeleteChat}>
                        <div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                    <path d="M6.5 5H16.5" stroke="#EE6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.5 8H16.5" stroke="#EE6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8.5 16H14.5" stroke="#EE6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M2.5 11H20.5M2.5 11H2.1C1.76863 11 1.5 11.2686 1.5 11.6V20.4C1.5 20.7314 1.76863 21 2.1 21H20.9C21.2314 21 21.5 20.7314 21.5 20.4V11.6C21.5 11.2686 21.2314 11 20.9 11H20.5H2.5ZM2.5 11V1.6C2.5 1.26863 2.76863 1 3.1 1H19.9C20.2314 1 20.5 1.26863 20.5 1.6V11H2.5Z" stroke="#EE6B6B" strokeWidth="1.5" />
                                </svg>
                            </div>
                            <p>Удалить чат</p>
                        </div>
                    </div>
                }

            </div>
        </div>
    )
}